import React from "react";

const Header = (props) => {
  return (
    <div className="page-header">
      <div className="page-header-left">
        {props.icon && (
          <div className="page-header-icon">{props.icon}</div>
        )}
        <div>
          {props.route && <div className="page-header-route">{props.route}</div>}
          <h1 className="page-header-title">{props.title}</h1>
        </div>
      </div>
      <div className="page-header-actions">{props.actions}</div>
    </div>
  );
};

export default Header;
